var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFieldStruct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95708 11.9012C5.80974 11.9813 6.22738 12.3817 6.22738 13.1506V14.7256C6.22738 15.5798 6.558 15.9269 7.37587 15.9269H7.60789V16.6797H7.28886C5.91995 16.6797 5.2761 16.087 5.2761 14.843V13.4816C5.2761 12.6273 4.95708 12.3444 4 12.3444V11.33C4.95708 11.33 5.2761 11.047 5.2761 10.1927V8.83663C5.2761 7.59263 5.91995 7 7.28886 7H7.60789V7.7528H7.37587C6.558 7.7528 6.22738 8.09984 6.22738 8.95408V10.5238C6.22738 11.2926 5.80974 11.693 4.95708 11.7731V11.9012ZM11.8086 17H11.0603L11.6114 13.9621H12.7193L11.8086 17ZM19.0429 11.7784C18.1903 11.6983 17.7726 11.2979 17.7726 10.5291V8.95408C17.7726 8.09984 17.442 7.7528 16.6241 7.7528H16.3921V7H16.7111C18.08 7 18.7239 7.59263 18.7239 8.83663V10.1981C18.7239 11.0523 19.0429 11.3353 20 11.3353V12.3497C19.0429 12.3497 18.7239 12.6327 18.7239 13.4869V14.843C18.7239 16.087 18.08 16.6797 16.7111 16.6797H16.3921V15.9269H16.6241C17.442 15.9269 17.7726 15.5798 17.7726 14.7256V13.1559C17.7726 12.3871 18.1903 11.9867 19.0429 11.9066V11.7784Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldStruct);
export default ForwardRef;